var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Box, Button, TextField } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { CREATE_NOTIFICATION_TEMPLATE_VARIABLE } from 'common/graphql/mutations/notification/create-notification-template-variable';
import { NOTIFICATION_TEMPLATE_VARIABLES } from 'common/graphql/queries/notification/notification-template-variable';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import { notificationTemplateVariableCreateValidationSchema } from 'common/validationSchemas/notificationTemplateVariableValidationSchema';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
var NotificationTemplateVariableAddNew = function () {
    var _a = useState(undefined), file = _a[0], setFile = _a[1];
    var _b = useState(false), isAddNew = _b[0], setIsAddNew = _b[1];
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var createNotificationTemplate = function (data) {
        return useMutation(CREATE_NOTIFICATION_TEMPLATE_VARIABLE, {
            variables: {
                createNotificationTemplateVariableData: __assign({}, data)
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: NOTIFICATION_TEMPLATE_VARIABLES
                },
            ]
        });
    };
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: "\u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0430",
            severity: SnackbarSeverity.SUCCESS
        }));
        setFile(undefined);
        setIsAddNew(false);
    };
    var onError = function (_a) {
        var code = _a.code;
        dispatch(openSnackbar({
            message: code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var handleExecuteMutation = useDynamicMutation(createNotificationTemplate, onSuccess, onError).handleExecuteMutation;
    var handleReset = function () {
        setIsAddNew(false);
        formik.resetForm();
    };
    var handleSubmit = function (data) {
        handleExecuteMutation(__assign({}, data));
        formik.resetForm();
    };
    var handleChangeWrapper = function (e) {
        formik.setFieldError(e.target.name, undefined); // <- reset error on the field
        formik.handleChange(e); // <- call original Formik's change handler
    };
    var formik = useFormik({
        initialValues: { name: '', description: undefined, defaultValueRu: undefined, defaultValueEn: undefined },
        validationSchema: notificationTemplateVariableCreateValidationSchema,
        onSubmit: handleSubmit,
        validateOnChange: false,
        validateOnBlur: false
    });
    return (_jsx(Box, __assign({ sx: { width: '100%' } }, { children: isAddNew ? (_jsxs("form", __assign({ className: "flex flex-col space-y-10 pt-20", onSubmit: formik.handleSubmit, onReset: formik.handleReset }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-10 w-full items-center" }, { children: [_jsx(TextField, { className: "w-full", label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435", autoFocus: true, name: "name", value: formik.values['name'], onChange: handleChangeWrapper, error: Boolean(formik.errors['name']), helperText: formik.errors['name'] }, void 0), _jsx(TextField, { className: "w-full", label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", multiline: true, autoFocus: true, name: "description", value: formik.values['description'] || '', onChange: handleChangeWrapper, error: Boolean(formik.errors['description']), helperText: formik.errors['description'] }, void 0), _jsx(TextField, { className: "w-full", label: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E (RU)", autoFocus: true, name: "defaultValueRu", value: formik.values['defaultValueRu'] || '', onChange: handleChangeWrapper, error: Boolean(formik.errors['defaultValueRu']), helperText: formik.errors['defaultValueRu'] }, void 0), _jsx(TextField, { className: "w-full", label: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E (EN)", autoFocus: true, name: "defaultValueEn", value: formik.values['defaultValueEn'] || '', onChange: handleChangeWrapper, error: Boolean(formik.errors['defaultValueEn']), helperText: formik.errors['defaultValueEn'] }, void 0)] }), void 0), _jsxs("div", __assign({ className: "flex flex-row space-x-10" }, { children: [_jsx(Button, __assign({ type: "reset", color: "secondary", onClick: function () { return handleReset(); } }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ type: "submit" }, { children: t('Сохранить') }), void 0)] }), void 0)] }), void 0)) : (_jsx(Button, __assign({ type: "submit", onClick: function () { return setIsAddNew(true); } }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" }), void 0)) }), void 0));
};
export default NotificationTemplateVariableAddNew;
